import type MarketingClient from '@travelata-libs/tracker';
import type { ApiServiceInterface, SentryService } from '@travelata-libs/utils';
import { createPinia, type StateTree, type Pinia } from 'pinia';
import Vue from 'vue';
import type { Store } from 'vuex';
import ClientOnly from '@/shared/ui/ClientOnly.vue';
import { container } from './Container';
import {
  API_SERVICE_TOKEN,
  APP_CONFIG_TOKEN,
  MARKETING_CLIENT_TOKEN,
  PINIA_TOKEN,
  STORE_TOKEN,
  SENTRY_SERVICE_TOKEN,
} from './tokens';
import type { AppConfig } from './types';
import ServerOnly from '../ui/ServerOnly.vue';

Vue.component('ClientOnly', ClientOnly);
Vue.component('ServerOnly', ServerOnly);
export interface InitLibraryOptions {
  store: Store<unknown>;
  config: AppConfig;
  apiService?: ApiServiceInterface;
  sentry?: SentryService;
  pinia?: Pinia;
  piniaState?: Record<string, StateTree>;
  marketingClient?: MarketingClient | null;
}

export function initLibrary(options: InitLibraryOptions): void {
  const pinia = options.pinia ?? createPinia();

  if (options.piniaState) pinia.state.value = options.piniaState;

  container.register(STORE_TOKEN, options.store);
  container.register(APP_CONFIG_TOKEN, options.config);
  container.register(PINIA_TOKEN, pinia);
  if (options.sentry) {
    container.register(SENTRY_SERVICE_TOKEN, options.sentry);
  }
  if (options.apiService) {
    container.register(API_SERVICE_TOKEN, options.apiService);
  }
  if (options.marketingClient) {
    container.register(MARKETING_CLIENT_TOKEN, options.marketingClient);
  }
}

export function useSentryService(): SentryService {
  return container.resolve(SENTRY_SERVICE_TOKEN);
}
